import { useQueryClient } from "@tanstack/react-query";
import { uploadDocument } from "../api";
import { useDomainMutation } from "@/modules/common/hooks/domain-mutation.hook";

const useUploadDocument = () => {
  const queryClient = useQueryClient();

  const mutationUploadDocument = useDomainMutation<
    any,
    { response?: { data?: { message?: string } } },
    { trackId?: string; formData: FormData }
  >(({ trackId, formData }) => uploadDocument(trackId || "", formData), {
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["track-documents"] });
    },
  });

  return mutationUploadDocument;
};

export default useUploadDocument;
